import React from "react";
import T from "prop-types";
import {
  CurrencyField,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { COST } from "APP_ROOT/constants";
import { connect } from "react-redux";
import { applyLotCost } from "MODULES/inventories/actions";
import { dollars } from "LIB/formatters/currency";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={4} mdOffset={4}>
            <CurrencyField name={COST} label="Cost EA" />
          </Col>
        </FormRow>
        <FormRow>
          <hr className="hr-xs hr-dashed" />
          <h5 className="h3 text-center">
            Ext Cost:{" "}
            {dollars(
              props.getFieldValue(COST) * Number(props.inventory.quantity)
            )}
          </h5>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  inventory: T.shape({})
};

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(applyLotCost(data))
}))(
  form({
    form: "applyLotCost"
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/ApplyLotCost/Form.jsx